import { render } from "./Ranking_journey.vue?vue&type=template&id=26513abb&scoped=true"
import script from "./Ranking_journey.vue?vue&type=script&lang=js"
export * from "./Ranking_journey.vue?vue&type=script&lang=js"

import "./Ranking_journey.vue?vue&type=style&index=0&id=26513abb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26513abb"]])

export default __exports__